module.exports = __webpack_public_path__ + "static/media/screenshot(40).02fad150.jpg";